import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import moment from 'moment';

// Icons 

import MoreVertIcon from '@mui/icons-material/MoreVert';
import getStatusColor from '../../../util/style/getStatusColor';
import { getGroup, getGroupSize } from '../../../routes/hacker/users';
import { useAppSelector } from '../../../redux/hooks';
import getCapitalizedString from '../../../util/style/getCapitalizedString';
import ApartmentIcon from '@mui/icons-material/Apartment';

type Props = {
    item: any; 
};


const GroupRow: React.FC<Props> = ({ item }) => {

  const colors = useAppSelector(state => state.theme.colors); 
  const selectedGroup = useAppSelector((state) => state.groupsAccess.selectedGroup); 

  const [groupSize, setGroupSize] = useState(0); 


  // --

  const handleGroupSize = async () => { 

    const res = await getGroupSize(item?._id) as any;

    if (res.data.status === 200) { 

      setGroupSize(res.data.size); 

    }; 

  }; 

  // -- 

  useEffect(() => { 

    handleGroupSize(); 

  },[item]); 

  return (

    <Box 
      sx={{ 
      display: 'flex', 
      flexDirection: 'row',
      alignItems: 'center', 
      width: '100%',
      fontSize: 12, 
      height: 50,
      backgroundColor: (selectedGroup?._id == item?._id) ? colors?.sectionHover : 'transparent', 
      '&:hover': { backgroundColor: colors?.sectionHover }
    }}>

            <div style={{ 
                display: 'flex', 
                flexDirection: 'row',
                alignItems: 'center',
                width: '28%',
                marginLeft: '2%',  
                textAlign: 'left',
                overflow: 'hidden',
            }}>

              <ApartmentIcon sx={{ marginRight: 3, color: 'rgba(50, 50, 100, 0.5)' }} />
              
              {item?.name}
              
            </div>

            <div style={{ 
                width: '20%', 
                textAlign: 'left',
                overflow: 'hidden', 
            }}>{item?._id}</div>

            <div style={{ 
                width: '20%', 
                textAlign: 'left',
                overflow: 'hidden', 
            }}>{moment.utc(item?.updatedAt).format('LL')}</div>

            <div style={{ 
                width: '10%', 
                textAlign: 'left',
                overflow: 'hidden',
            }}>{groupSize}</div>

            <div style={{ 
                width: '10%', 
                textAlign: 'left',
                overflow: 'hidden', 
            }}>                
            
              <strong 
                style={{ 
                  padding: 5,
                  borderRadius: 7,
                  backgroundColor: getStatusColor(item?.status), 
                  color: 'white', 
                }}>
              {getCapitalizedString(item?.status)}
              </strong>
          </div>

            <div style={{ 
                width: '5%', 
                textAlign: 'left',
                overflow: 'hidden', 
            }}>
                <Box
                  sx={{ 
                    display: 'flex', 
                    flexDirection: 'row',
                    alignItems: 'center', 
                    justifyContent: 'space-evenly', 
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    '&:hover': { backgroundColor: 'rgba(45, 153, 207, 0.6)'}
                  }}
                >
                  <MoreVertIcon></MoreVertIcon>
                </Box>

            </div>

    </Box>

  );

};

export default GroupRow;